import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setFootprintingDairyFeedProduction } from "services";

import { FOOTPRINTING_DAIRY, FOOTPRINTING_DAIRY_FEED_PRODUCTION } from "consts";

import { DairyFeedProduction } from "models";

export const useMutateFootprintingDairyFeedProduction = (feedInformationId: string, onSuccess?: () => void) => {
  const queryClient = useQueryClient();
  return useMutation(
    {
      mutationKey: [FOOTPRINTING_DAIRY_FEED_PRODUCTION, feedInformationId],
      mutationFn: (data: DairyFeedProduction) => setFootprintingDairyFeedProduction(feedInformationId, data),
      onSuccess: async () => {
        await queryClient.invalidateQueries({ queryKey: [FOOTPRINTING_DAIRY_FEED_PRODUCTION, feedInformationId] });
        await queryClient.invalidateQueries({ queryKey: [FOOTPRINTING_DAIRY] });
        onSuccess?.();
      },
    },
    queryClient
  );
};
